/* eslint-disable */
import services from 'services';

export default {
  list: async ({ commit }, shopId) => {
    const res = await services.SupplierService.getSuppliersByShopId(shopId);
    commit('SET_LIST', res);
  },
};
